import { SHA3 } from 'crypto-js';

import { TransferAppState } from '@wetransfer/ad-sdk';

import { consentModel } from '@wetransfer/transfer/modules/consent-manager';

export const getUserDBUserKey = ({
  auth0UserId,
  domainUserId,
}: {
  auth0UserId?: string;
  domainUserId?: string;
}): string => {
  if (auth0UserId) {
    // This function has to be in sync with the bulk-update to have the same userKey in UserDB
    return SHA3(auth0UserId, { outputLength: 224 }).toString();
  }

  if (domainUserId) {
    return `sp-${domainUserId}`;
  }

  return `sp-${Math.random()}`;
};

export const getUserKey = ({
  auth,
  session,
}: Pick<TransferAppState, 'auth' | 'session'>): string => {
  const queryString = window.location.search;
  const clientParams = new URLSearchParams(queryString);

  const userKeyOverride = clientParams.get('user_key');

  if (userKeyOverride) {
    return userKeyOverride;
  }

  return getUserDBUserKey({
    auth0UserId: auth?.auth0UserId,
    domainUserId: session?.domainUserId,
  });
};

export const hasUserConsentedAdvertisement = (): boolean => {
  // the user has rejected all consent
  if (consentModel.hasRejectedAll()) {
    return false;
  }

  // the user has rejected some consent
  if (consentModel.hasPartialConsent()) {
    return false;
  }

  // the user has accepted all consent and we can show ads
  return consentModel.hasFullConsent();
};
